module.exports = __webpack_public_path__ + "img/contact.447309ef.jpg";